<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
      <!-- <span slot="button" v-if="permission.find(a => a.name=='PromotionActivity.Create')">
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span>
      <span slot="button" v-if="permission.find(a => a.name=='PromotionActivity.Publish')">
        <a-button type="primary" @click="batchPublish" :disabled="!hasSelected" :loading="loading">批量发布</a-button>
      </span> -->
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange" :rowSelection="rowSelection">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <!-- <a @click="handleProduct(rowKey.data)" :disabled="!permissionChecker('PromotionActivity.Query')">产品</a>
          <a-divider type="vertical" /> -->
          <a @click="handleScope(rowKey.data)" :disabled="!permissionChecker('PromotionActivity.Query')">范围</a>
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleScope(rowKey.data)" :disabled="!permissionChecker('PromotionScope.Query')">范围</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleEdit(1,rowKey.data)" :disabled="!(permissionChecker('PromotionActivity.Edit') &&  rowKey.data.isActive == false)">编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="handleCancel(rowKey.data)" :disabled="!(permissionChecker('PromotionActivity.Cancel')  &&  rowKey.data.isActive==true && rowKey.data.isCancel==false)">注销</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="deldata(rowKey.data)" :disabled="!(permissionChecker('PromotionActivity.Delete')  &&  rowKey.data.isActive == false)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </template>
    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-PromotionActivity-add slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-PromotionActivity-add>
    </hp-manager-modal>
    <hp-manager-modal :title="params.title+'  促销产品'" v-model="productListVisible" width="1200px">
      <hp-manager-page-promotionProduct-list slot="slot" @submit-success="refreshCurrent" @cancel="productListVisible = false" :paramsX="params"></hp-manager-page-promotionProduct-list>
    </hp-manager-modal>
    <hp-manager-modal :title="params.title+' '+ params.productName+'  促销范围'" v-model="scopeListVisible" width="1000px">
      <hp-manager-page-promotionScope-list slot="slot" @submit-success="refreshCurrent" @cancel="scopeListVisible = false" :paramsX="params">
      </hp-manager-page-promotionScope-list>
    </hp-manager-modal>
    <hp-manager-modal title="确认注销" v-model="cancelVisible" width="500px">
      <hp-manager-page-PromotionActivity-cancel slot="slot" @submit-success="refreshCurrent" @cancel="cancelVisible = false" :paramsX="params">
      </hp-manager-page-PromotionActivity-cancel>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch, truncateSync } from "fs";
import hpManagerPagePromotionActivityAdd from "./Add";
import hpManagerPagePromotionProductList from "./ProductList";
import hpManagerPagePromotionScopeList from "./ScopeList";
import hpManagerPagePromotionActivityCancel from "./CancelConfirm";
import config from "@/config";
import { setTimeout } from "timers";

let promotionActivityTypeOptions = [];
export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPagePromotionActivityAdd,
    hpManagerPagePromotionProductList,
    hpManagerPagePromotionScopeList,
    hpManagerPagePromotionActivityCancel
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "title",
          name: "标题"
        },
        {
          type: "dateFilter",
          key: "filterTime",
          name: "有效期"
        }
        // {
        //   type: "select",
        //   key: "activityType",
        //   name: "类型",
        //   options: []
        // }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 70,
          scopedSlots: { customRender: "action" }
        },
        {
          title: "标题",
          dataIndex: "title",
          sorter: true
        },
        // {
        //   title: "活动类型",
        //   width: 150,
        //   dataIndex: "activityTypeName"
        // },
        {
          title: "产品编码",
          dataIndex: "productCode",
          width: 120
        },
        {
          title: "产品名称",
          dataIndex: "productName",
          width: 280
        },
        {
          title: "规格",
          dataIndex: "specDes",
          width: 180
        },
        {
          title: "活动价格",
          dataIndex: "activityPrice",
          width: 110
        },
        {
          title: "有效期",
          width: 200,
          dataIndex: "startTime",
          customRender: (text, row, index) => {
            return (
              this.formatDate(row.startTime, "YYYY-MM-DD") +
              " ~ " +
              this.formatDate(row.endTime, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "状态",
          width: 70,
          dataIndex: "isActive",
          customRender: (text, row, index) => {
            return row.isActive == true ? "正常" : "无效";
          }
        },
        // {
        //   title: "撤销状态",
        //   width: 100,
        //   dataIndex: "isCancel",
        //   customRender: (text, row, index) => {
        //     return row.isCancel == true ? "是" : "否";
        //   }
        // },
        // {
        //   title: "撤销时间",
        //   width: 150,
        //   dataIndex: "cancelTime",
        //   customRender: (text, row, index) => {
        //     return this.formatDate(row.cancelTime, "YYYY-MM-DD HH:mm:ss");
        //   }
        // },
        {
          title: "修改时间",
          dataIndex: "creationTime",
          width: "10%",
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        {
          title: "",
          PromotionActivityType: ""
        },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      productListVisible: false,
      scopeListVisible: false,
      cancelVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "500px",
      checkedRowKeys: [],
      checkedRows: [],
      permission: [],
      title: "",
      rowSelection: null
    };
  },
  async mounted() {
    this.permission = this.getPermission("PromotionActivity");
    //this.GetPromotionActivityTypeOptions();
    this.getDatas(this.filterdata);
    // this.rowSelection = {
    //   onChange: this.onSelectChange,
    //   getCheckboxProps: this.getCheckboxProps
    // };
  },
  computed: {
    hasSelected() {
      return this.checkedRowKeys.length > 0;
    }
  },
  methods: {
    handleProduct(record) {
      this.params = record;
      this.productListVisible = true;
    },
    handleScope(record) {
      this.params = record;
      this.scopeListVisible = true;
    },
    handleCancel(record) {
      this.params = record;
      this.cancelVisible = true;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      let selected = [];
      selectedRows.forEach((element, index) => {
        selected.push(element.id);
      });
      this.checkedRowKeys = selected;
      this.checkedRows = selectedRows;
      this.rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: this.getCheckboxProps
      };
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.isActive == true // Column configuration not to be checked
        }
      };
    },
    async GetPromotionActivityTypeOptions() {
      let dictionary = await api.GetDictionaryForSelect({ type: 5 });
      if (dictionary) {
        promotionActivityTypeOptions = [];
        dictionary.forEach(a => {
          promotionActivityTypeOptions.push({
            name: a.text,
            val: a.value
          });
        });
      }
      this.filter.filter(
        a => a.key == "activityType"
      )[0].options = promotionActivityTypeOptions;
    },
    async batchPublish() {
      this.loading = true;
      let that = this;
      let request = { selectedIdList: this.checkedRowKeys };
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "您确定要发布以下活动吗？",
          content: (
            <div>
              <br />
              {this.checkedRows.map(function(todo, index) {
                return <p>{index + 1 + "." + todo.title}</p>;
              })}
            </div>
          ),
          onOk() {
            that.doPublish(request);
          },
          onCancel() {}
        });
      });
      this.loading = false;
    },
    async doPublish(request) {
      let res = await api.BatchPublishPromotionActivity(request);
      if (res) {
        this.$message.success("发布成功");
        this.refreshCurrent();
      }
    },
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.title = p.values.title;
      this.filterdata.activityType = p.values.activityType;
      this.filterdata.startTime =
        p.values.filterTime[0] != null
          ? p.values.filterTime[0].startOf("day").valueOf()
          : null;
      this.filterdata.endTime =
        p.values.filterTime[1] != null
          ? p.values.filterTime[1].startOf("day").valueOf()
          : null;

      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑活动";
      } else if (type == 2) {
        this.title = "活动详情";
        this.isabl = true;
      } else {
        this.title = "新增活动";
      }
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },
    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.DelPromotionActivity({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },

    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = false;
      this.cancelVisible = false;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.checkedRowKeys = [];
      this.rowSelection = {
        selectedRowKeys: [],
        onChange: this.onSelectChange,
        getCheckboxProps: this.getCheckboxProps
      };

      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.filters.code && table.filters.code.length > 0) {
        console.log(table.filters);
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetPromotionActivityList(options);
      this.datas = data.items;
      console.log(data);
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Promotions/Activity/List.vue